import { useState } from 'react';
import { connect } from 'react-redux';
import { array, func, number, string } from 'prop-types';
import cn from 'classnames';

import { ReactComponent as Check } from '../../styles/icon/icon_check.svg';
import { setPageStatus } from '../../redux/swaggerApi/swaggerApi';
import { DropDown } from '../../elements';
import { setApiVersion } from '../../redux/swaggerApi/swaggerApi';
import { ReactComponent as Arrow } from '../../styles/icon/arrow-pink.svg';
import './versions.scss';

const mapStateToProps = (state) => ({
  selectedVersion: state.swaggerApi.selectedVersion,
  versions: state.swaggerApi.versions,
});

const mapDispatchToProps = {
  setApiVersion,
  setPageStatus
};

ApiVersions.propTypes = {
  selectedVersion: number,
  versions: array,
  setApiVersion: func,
  location: string
};

function ApiVersions({ selectedVersion, versions, setApiVersion, location, setPageStatus }) {
  const [isOpened, toogleDropdown] = useState(false);
  return (
    <div className={cn("api_filter", {
      [`api_filter__${location}`]: location,
      "api_filter--hidden": !selectedVersion,
    })}>
      {/* <span className="api_filter__label label">version: </span> */}
      <DropDown
        trigger={() => (
          <div className="api_filter--name">
            <div
              className={cn("api_filter__version api_version", {
                "api_filter__version--active": isOpened
              })}
            >
              <span>
                {location === 'swagger' ? 'Version ' : 'v'}
                {selectedVersion}
              </span>
              <Arrow />
            </div>
          </div>
        )}
        // className={postman.postman}
        classNameBody="api_filter__body api_body"
        onTriggerClick={() => toogleDropdown(!isOpened)}
        handleClose={() => toogleDropdown(false)}
        isOpened={isOpened}
      >
        <div className="api_filter__list">
          {versions?.map((c, index) => (
            <div
              key={index}
              className={cn("api_filter__item api_item", {
                "api_filter__item--active": c.version === selectedVersion
              })}
              onClick={() => {
                setPageStatus({ status: false });
                toogleDropdown(false);
                setApiVersion({ version: c.version });
              }}
            >
              <div>V{c.version}</div>
              {c.version === selectedVersion && (
                <div><Check /></div>
              )}
            </div>
          ))}
        </div>
      </DropDown>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiVersions);
